var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#1976d2",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.833 9.206l-1.41-.052-.305 8.342 1.41.052zM11.697 9.18h1.41v8.342h-1.41zM10.686 17.496l-.305-8.342-1.41.052.306 8.342z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.013 5.702v1.41h1.47l1.165 13.245A.705.705 0 0 0 7.35 21h10.08c.366 0 .671-.28.703-.643l1.165-13.245h1.493v-1.41H4.013zM16.785 19.59h-8.79L6.899 7.112h10.985L16.785 19.59z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.705 3H10.1c-.647 0-1.174.527-1.174 1.175v2.232h1.41V4.41h4.135v1.997h1.41V4.175c0-.648-.527-1.175-1.175-1.175z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete24);
export default __webpack_public_path__ + "static/media/delete-24.4722f58f.svg";
export { ForwardRef as ReactComponent };